import React from 'react';
import classNames from 'classnames';

import { PaddingContainer, WidthContainer } from '@components';
import { ContactBar } from './ContactBar/ContactBar';
import { QuoteWithButtonsProps } from './QuoteWithButtonsProps';

import * as styles from './QuoteWithButtons.module.scss';

export const QuoteWithButtons: React.FC<QuoteWithButtonsProps> = ({
	className = 'white-bg',
	author,
	children,
}) => {
	return (
		<PaddingContainer className={classNames(styles.container, className)}>
			<WidthContainer maxWidth={750} className={styles.root}>
				<div className="row no-gutters">
					<div className="col-12 col-sm-7 col-md-9 col-lg-8 pr-md-3 pt-md-4">
						<div className={classNames(styles.content, 'p-4 pl-5 mb-sm-5 z-9')}>
							{children}
						</div>
						<ContactBar
							email={author.email}
							linkedIn={author.linkedIn}
							className={styles.mediumDimension}
						/>
					</div>
					<div
						className={classNames(
							styles.description,
							'col-12 col-sm-5 col-md-3 col-lg-4'
						)}
					>
						<div
							className={classNames(
								styles.authorPhoto,
								'd-flex align-items-end justify-content-end'
							)}
						>
							<img src={author.photo} className="z-9" />
						</div>
						<div className="d-flex flex-column">
							<p className="font-600 orange-font font-18 my-2">{author.name}</p>
							<p className={classNames(styles.position, 'font-size-14 mb-3')}>
								{author.position}
							</p>
						</div>
						<ContactBar
							email={author.email}
							linkedIn={author.linkedIn}
							className={styles.lowDimension}
						/>
					</div>
				</div>
			</WidthContainer>
		</PaddingContainer>
	);
};
